{
  "common.actions.buscar": {
    "defaultMessage": "Buscar"
  },
  "common.actions.close": {
    "defaultMessage": "Cerrar"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Crear"
  },
  "common.actions.edit": {
    "defaultMessage": "Editar"
  },
  "common.actions.select": {
    "defaultMessage": "Seleccionar..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Seleccionar todos"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Seleccionar ninguno"
  },
  "common.actions.share": {
    "defaultMessage": "Share"
  },
  "common.actions.view": {
    "defaultMessage": "Ver info"
  },
  "common.apiError.body": {
    "defaultMessage": "Intenta nuevamente dentro de unos instantes. {br}Si el error persiste, ponte en contacto con nosotros."
  },
  "common.apiError.title": {
    "defaultMessage": "El servidor no está respondiendo"
  },
  "common.confirmationModal.cancelBtnText": {
    "defaultMessage": "Cancelar"
  },
  "common.confirmationModal.confirmBtnText": {
    "defaultMessage": "Confirmar"
  },
  "common.copyBtn.copied": {
    "defaultMessage": "Copied"
  },
  "common.fatalError.body": {
    "defaultMessage": "Probá volver al inicio. Si el problema continúa, volvé a iniciar sesión o contactanos."
  },
  "common.fatalError.loginAgainBtn": {
    "defaultMessage": "Iniciar sesión"
  },
  "common.fatalError.refreshBtn": {
    "defaultMessage": "Ir al inicio"
  },
  "common.fatalError.title": {
    "defaultMessage": "Algo salió mal"
  },
  "common.fileInput.btnText": {
    "defaultMessage": "Seleccionar archivos"
  },
  "common.form.cancelBtnText": {
    "defaultMessage": "Cancelar"
  },
  "common.form.dateRange.endDatePlaceholder": {
    "defaultMessage": "Hasta"
  },
  "common.form.dateRange.startDatePlaceholder": {
    "defaultMessage": "Desde"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Hubo un error. {br} Verifica e intenta nuevamente."
  },
  "common.form.exitCancelBtnText": {
    "defaultMessage": "Continuar editando"
  },
  "common.form.exitConfirmBtnText": {
    "defaultMessage": "Salir sin guardar"
  },
  "common.form.exitPrompt": {
    "defaultMessage": "Deseas realmente salir? {br}Cualquier cambio no guardado será perdido."
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Guardar"
  },
  "common.form.savedBtnText": {
    "defaultMessage": "Guardado"
  },
  "common.form.updateBtnText": {
    "defaultMessage": "Guardar"
  },
  "common.form.updatedBtnText": {
    "defaultMessage": "Guardado"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Idioma"
  },
  "common.listFilter.apply": {
    "defaultMessage": "Aplicar"
  },
  "common.listFilter.reset": {
    "defaultMessage": "Reset"
  },
  "common.noResults": {
    "defaultMessage": "No se encontraron resultados"
  },
  "common.pagination.countText": {
    "defaultMessage": "Mostrando {showCount, plural, =0 {no items} one {# item} other {# items}} de {totalCount}"
  },
  "common.reset": {
    "defaultMessage": "Reset"
  },
  "common.text.clear": {
    "defaultMessage": "Borrar"
  },
  "common.timezoneSelect.defaultLabel": {
    "defaultMessage": "Timezone"
  },
  "common.viewError.actions.back": {
    "defaultMessage": "Volver"
  },
  "common.viewError.actions.home": {
    "defaultMessage": "Ir al inicio"
  },
  "common.viewError.actions.retry": {
    "defaultMessage": "Reintentar"
  },
  "common.viewError.details.toggle": {
    "defaultMessage": "Detalles técnicos"
  },
  "common.viewError.error.help": {
    "defaultMessage": "Intentá de nuevo. Si el problema continúa, contactanos."
  },
  "common.viewError.error.title": {
    "defaultMessage": "No pudimos cargar esta información"
  },
  "common.viewError.forbidden.help": {
    "defaultMessage": "Si creés que deberías tener acceso, pedíselo a un administrador."
  },
  "common.viewError.forbidden.title": {
    "defaultMessage": "No tenés permisos para ver esto"
  },
  "common.viewError.notFound.help": {
    "defaultMessage": "El elemento no existe o fue eliminado. Revisá el enlace o volvé al listado."
  },
  "common.viewError.notFound.title": {
    "defaultMessage": "No encontramos lo que buscabas"
  },
  "common.viewError.unavailable.help": {
    "defaultMessage": "Revisá tu conexión e intentá de nuevo en unos instantes."
  },
  "common.viewError.unavailable.title": {
    "defaultMessage": "No pudimos conectarnos"
  },
  "stream.thumbnails.empty": {
    "defaultMessage": "No hay miniaturas disponibles"
  },
  "stream.thumbnails.loading": {
    "defaultMessage": "Cargando miniaturas"
  },
  "common.resultsCount": {
    "defaultMessage": "{count, plural, zero {Sin resultados}one {1 resultado}other {# resultados}}"
  }
}
